// extracted by mini-css-extract-plugin
export default {"teachTool":"teachTool-HWoDH","header":"header-uywyx","teachToolOptions":"teachToolOptions-kgd2k","choice":"choice-rjJ4q"};